import { Injectable } from '@angular/core';
import { ApiService } from '@services/api.service';
import { Observable } from 'rxjs';
import { AssetTypeRequest, AssetTypeResponse } from '@entities/assetType';

@Injectable({
  providedIn: 'root',
})
export class AssetTypeService {
  constructor(private api: ApiService) {}

  /**
   * アカウント一覧を取得する
   * @returns アカウント一覧
   */
  findAll(): Observable<AssetTypeResponse[]> {
    const url = '/asset-types';
    return this.api.get<AssetTypeResponse[]>(url);
  }

  /**
   * アセットタイプを追加する
   * @param request 登録内容
   */
  add(request: AssetTypeRequest): Observable<void> {
    const url = '/asset-types';
    return this.api.post<void>(url, request);
  }

  /**
   * アセットタイプを更新する
   * @param request
   * @returns
   */
  update(request: AssetTypeRequest): Observable<AssetTypeResponse> {
    const url = `/asset-types/${request.assettypeId}`;
    return this.api.put<AssetTypeResponse>(url, request);
  }

  /**
   * アセットタイプを削除する
   * @param request 主キー
   * @returns
   */
  delete(request: string[]): Observable<void> {
    const url = '/asset-types/_delete';
    return this.api.post<void>(url, request);
  }
}
